import styled from 'styled-components';
import { Box } from '@mui/system';
import loginBackground from '../../assets/img/login-background.jpg';

export const AuthContainerStyled = styled(Box)`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(${loginBackground});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  background-color: rgba(0, 0, 0, 0.64);
`;
